import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { MobileThemeProvider } from './context/MobileThemeProvider';
import MobileLayout from './layout/MobileLayout';
import MobileApplication from './pages/MobileApplication';
import { MobileThanksLoan, MobileThanksFactoring } from './pages/MobileThanks';
import MobileKayttoehdot from './pages/MobileKayttoehdot';
import MobileTietosuoja from './pages/MobileTietosuoja';
import MobileFaq from './pages/MobileFaq';
import MobileApplicationStatus from './pages/MobileApplicationStatus';

export default function MobileApp() {
  return (
    <MobileThemeProvider>
      <Routes>
        <Route element={<MobileLayout />}>
          <Route index element={<MobileApplication />} />
          <Route path="kiitos-yrityslaina" element={<MobileThanksLoan />} />
          <Route path="kiitos-laskurahoitus" element={<MobileThanksFactoring />} />
          <Route path="hakemus/:token" element={<MobileApplicationStatus />} />
          <Route path="kayttoehdot" element={<MobileKayttoehdot />} />
          <Route path="tietosuojaseloste" element={<MobileTietosuoja />} />
          <Route path="faq" element={<MobileFaq />} />
        </Route>
      </Routes>
    </MobileThemeProvider>
  );
}
